/**
 * Ensures that the debounced function isn't called for at least one animation frame before
 * the callback is invoked.
 *
 * This is useful if we want to perform cleanup after a continuous user interaction is finished.
 *
 * E.g. If an interaction is listening to scroll events, then it can continue to call the debounced
 *  function on every event, which will at least be once per animation frame. As soon as there is
 *  a gap in the animation frames then the interaction must have stopped.
 *
 * NOTE: This is better than using a constant debounce time as frames might occasionally take a
 *  long time and thus cause the debounced function to fire the callback despite the interaction
 *  not yet being complete.
 */
export const animationFrameDebounce = (callback) => {
    let rafIf;

    return (...args) => {
        if (rafIf) {
            cancelAnimationFrame(rafIf);
        }

        rafIf = requestAnimationFrame(() => {
            rafIf = requestAnimationFrame(() => {
                callback(...args);
            });
        });
    };
};

export default animationFrameDebounce;
